import type { IconComponent } from '@consta/icons/Icon'
import { IconForward } from '@consta/icons/IconForward'
import { GridItem } from '@consta/uikit/Grid'
import { Text } from '@consta/uikit/Text'
import type { ImportFilesResultViewMode } from '@core/core/types'
import type { FC } from 'react'
import { Link } from 'react-router-dom'

import css from './NewImportFromLocalFilesSelector.css'

type NewImportGridItemProps = {
  title: string
  gridClass: string
  disabled: boolean
  onSelect?: (mode: ImportFilesResultViewMode) => void
  link?: string
  mode: ImportFilesResultViewMode
  Icon: IconComponent
  description: string
}

export const NewImportGridItem: FC<NewImportGridItemProps> = ({
  title,
  gridClass,
  disabled,
  onSelect,
  link,
  mode,
  Icon,
  description,
}) => {
  const onClick = () => {
    if (!disabled) onSelect?.(mode)
  }

  const gridItem = (
    <GridItem col={1} className={gridClass} onClick={onSelect ? onClick : undefined}>
      <Icon className={css.icon} />
      <div className={css.gridItem}>
        <div>
          <Text
            size="s"
            weight="medium"
            view={disabled ? 'ghost' : 'primary'}
            lineHeight="xs"
            className={css.itemText}>
            {title}
          </Text>
          <Text view={disabled ? 'ghost' : 'secondary'} size="xs" lineHeight="2xs" weight="regular">
            {description}
          </Text>
        </div>
        {!!link && <IconForward view="primary" />}
      </div>
    </GridItem>
  )
  return link ? (
    <Link className={css.link} to={link}>
      {gridItem}
    </Link>
  ) : (
    gridItem
  )
}
